import { render, staticRenderFns } from "./edit-flow.vue?vue&type=template&id=8616503a&scoped=true&"
import script from "./edit-flow.vue?vue&type=script&lang=ts&"
export * from "./edit-flow.vue?vue&type=script&lang=ts&"
import style0 from "./edit-flow.vue?vue&type=style&index=0&id=8616503a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8616503a",
  null
  
)

export default component.exports